import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccionesDialog, EstadosContrato, RangoFechasValores } from '@models/base/identificadores.model';
import { ResindirContratoRequest } from '@models/contrato/resindirContratoRequest.model';
import { ContratosService } from '@services/contratos/contratos.service';
import { PersonasService } from '@services/personas/personas.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogGenerarResumenComponent } from '../form-editar-contrato/dialog-generar-resumen/dialog-generar-resumen.component';
import { DialogNuevaLiquidacionComponent } from '../form-editar-contrato/dialog-nueva-liquidacion/dialog-nueva-liquidacion.component';
import { DialogRescisionContratoComponent } from '../form-editar-contrato/dialog-rescision-contrato/dialog-rescision-contrato.component';
import { isFalsy } from 'utility-types';
import { DialogImputacionPropietarioComponent } from '@views/propietarios/dialog-imputacion-propietario/dialog-imputacion-propietario.component';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { EstadosContratoService } from '@services/estados-contratos/estados-contrato.service';
import { BaseDto } from '@models/base/baseDto.model';
import { TiposContratoService } from '@services/tipos-contrato/tipos-contrato.service';
import { ContratoFilter } from '@models/contrato/contratoFilter.model';
import { PersonaPropietarioDto } from '@models/propietarios/personaPropietarioDto.model';
import { InquilinoDto } from '@models/inquilino/inquilinoDto.model';
import { DatePipe } from '@angular/common';
import { TipoAjusteContratoService } from '@services/tipo-ajuste-contrato/tipoAjusteContrato.service';
import { TipoAjusteContratoDto } from '@models/tipo-ajuste-contrato/tipoAjusteContratoDto.model';
import { DialogNuevoReciboComponent } from '../dialog-nuevo-recibo/dialog-nuevo-recibo/dialog-nuevo-recibo.component';
import { SelectionModel } from '@angular/cdk/collections';
import { Console } from 'console';
import { DialogGenerarResumenMensualComponent } from '@views/generar-resumen-mensual/dialog-generar-resumen-mensual/dialog-generar-resumen-mensual.component';
import { ResultadoResumenInquilinoEnvioCorreoService } from '@services/resultado-proceso-resumen-masivo-inquilinos/resultado-proceso-resumen-masivo-inquilinos.service';
import { DeleteConfirmationModalComponent, DeleteConfirmationModalResult } from 'src/app/component/delete-confirmation-modal/delete-confirmation-modal.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogFechaLiquidacionComponent, DialogFechaLiquidacionResult } from '@views/comprobantes/dialog-fecha-liquidacion/dialog-fecha-liquidacion.component';

export class ContratoLista {

  public id: number = 0
  public numeroContrato: number = 0
  public legajo: string = ""
  public propiedadNombre: string = ""
  public propiedadLocalidad: string = ""
  public propiedadId: number = 0
  public inquilinoNombre: string = ""
  public inquilinoId: number = 0
  public propietarioId: number = 0
  public propietarioNombre: string = ""
  public porcentajeDiasCompletados: number = 0
  public tipoContrato: string = ""
  public fechaInicio: string = ""
  public fechaFin: string = ""
  public estadoNombre: string = ""
  public estadoId: number = 0
  public tipoAjuste: string = ""
  public contratoDto!: ContratoDetailDto
}

@Component({
  selector: 'app-listado-contratos',
  templateUrl: './listado-contratos.component.html',
  styleUrls: ['./listado-contratos.component.css'],
  providers: [DatePipe]
})


export class ListadoContratosComponent implements OnInit {

  private destroy$ = new Subject<void>();

  // 3. Constantes para sessionStorage
  private readonly STORAGE_KEY = 'contratos_filtros';
  data = false
  dataSource = new MatTableDataSource<ContratoLista>();
  displayedColumns: string[] = [];
  estadosContrato!: typeof EstadosContrato;
  porcentajeDiasCompletados: number = 0
  filterValues: any = {};
  filterSelectObjEstados: { name: string; columnProp: string; options: never[]; }[];
  contratoLista: ContratoLista[] = [];
  inquilinoNombre: string = ""
  filter: any;
  tipoBusqueda: string = "";
  @Input() idInquilino: number = 0
  @Input() idPropiedad: number = 0
  formControlBuscar = new FormControl('');
  selectTipoBusquedaControl!: string;

  private paginator!: MatPaginator;
  private sort!: MatSort;
  lstEstadosContrato!: BaseDto[];
  form: FormGroup;
  formBuilder = new FormBuilder
  lstTiposContrato!: BaseDto[];
  checkedFiltroAvanzado: boolean = false;
  rangoFecha: number = RangoFechasValores.Hoy // Hoy
  personaPropietarioDto?: PersonaPropietarioDto;
  propiedadBaseDto?: BaseDto;
  inquilinoDto?: InquilinoDto;
  idPropietario?: number;
  lstTiposAjuste!: TipoAjusteContratoDto[];
  selection = new SelectionModel<ContratoLista>(true, []);  // Permite selección múltiple
emptyBaseDto: BaseDto = new BaseDto();

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }
  constructor(
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private contratosService: ContratosService,
    private personasService: PersonasService,
    private estadosContratoService: EstadosContratoService,
    private tiposContratoService: TiposContratoService,
    private tipoAjusteContratoService: TipoAjusteContratoService,
    private resultadoResumenInquilinoEnvioCorreoService: ResultadoResumenInquilinoEnvioCorreoService,
    private router: Router,
    private datepipe: DatePipe,
  ) {

    this.form = this.formBuilder.group({
      TiposContrato: [''],
      TiposAjuste: [''],
      EstadosContrato: [''],
      NumeroContrato: [''],
      TiposLiquidacion: [''],
      FechaDesde: [''],
      FechaHasta: [''],
      Recindido: [''],
      Finalizado: [''],
    })

    this.filterSelectObjEstados = [
      {
        name: 'Tipo Contrato',
        columnProp: 'tipoContrato',
        options: []
      },
      {
        name: 'Estado Contrato',
        columnProp: 'estadoNombre',
        options: []
      }

    ]
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["select", "propiedadNombre", "numeroContrato", "accion"] :
        ["select", "propiedadNombre", "estadoNombre", "numeroContrato", "inquilinoNombre", "propietarioNombre", "duracion", "tipoContrato", "tipoAjuste", "accion"];
    });
  }



  ngOnInit() {
    this.getAllEstadosContrato()
    this.getAllTiposContrato()
    this.getAllTiposAjuste();

    // CASO 1: Vista con @Input (desde propiedad/inquilino) - NO usar sesión
    if (this.tieneInputsActivos()) {
      this.tipoBusqueda = "Propiedad";
      this.selectTipoBusquedaControl = "3";
      this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] };
      this.cargarDatosPorInputs();
    }
    // CASO 2: Vista general - Usar sesión
    else {
      this.restoreFiltersFromSession();
      this.tipoBusqueda = this.tipoBusqueda || "Propiedad";
      this.selectTipoBusquedaControl = this.selectTipoBusquedaControl || "3";
      this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] };
    }

    this.estadosContrato = EstadosContrato
    this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] }
    this.tipoBusqueda = this.tipoBusqueda || "Propiedad"
    this.selectTipoBusquedaControl = this.selectTipoBusquedaControl || "3"
    this.dataSource.filterPredicate = this.createFilter();
  }

  private tieneInputsActivos(): boolean {
    return !isFalsy(this.idInquilino) ||
      !isFalsy(this.idPropiedad) ||
      !isFalsy(this.idPropietario);
  }

  private cargarDatosPorInputs(): void {
    this.dataSource.data = [];

    if (!isFalsy(this.idInquilino)) {
      this.getAllByIdInquilinoAndIdPropiedad(this.idInquilino, 0);
    } else if (!isFalsy(this.idPropiedad)) {
      this.getAllByIdInquilinoAndIdPropiedad(0, this.idPropiedad);
    } else if (!isFalsy(this.idPropietario)) {
      this.getAllByIdInquilinoAndIdPropiedad(0, 0); // Ajustar según tu API
    }
  }

  ngOnDestroy(): void {
    this.saveFiltersToSession();
    this.destroy$.next();
    this.destroy$.complete();
  }



  ngOnChanges(changes: SimpleChanges): void {
    const isInitialized = this.lstEstadosContrato && this.lstTiposContrato;

    if (isInitialized && (changes['idPropiedad'] || changes['idInquilino'])) {
      if (!changes['idPropiedad']?.firstChange || !changes['idInquilino']?.firstChange) {
        // Solo filtrar si cambió dinámicamente
        this.filterContratos();
      }
    }
  }

  // 4. AGREGAR: Método para guardar filtros en sesión
  private saveFiltersToSession(): void {

    // NO guardar en sesión si estamos en vista filtrada por @Input
    if (this.tieneInputsActivos()) {
      return;
    }
    const filtros = {
      form: this.form.value,
      tipoBusqueda: this.tipoBusqueda,
      selectTipoBusquedaControl: this.selectTipoBusquedaControl,
      checkedFiltroAvanzado: this.checkedFiltroAvanzado,
      personaPropietarioDto: this.personaPropietarioDto,
      propiedadBaseDto: this.propiedadBaseDto,
      inquilinoDto: this.inquilinoDto,
      contratoLista: this.contratoLista,
      data: this.data
    };

    try {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(filtros));
    } catch (error) {
      console.error('Error guardando filtros en sesión:', error);
    }
  }

  // 5. AGREGAR: Método para restaurar filtros desde sesión
  private restoreFiltersFromSession(): void {
    try {
      const filtrosGuardados = sessionStorage.getItem(this.STORAGE_KEY);

      if (filtrosGuardados) {
        const filtros = JSON.parse(filtrosGuardados);

        // Restaurar formulario
        this.form.patchValue(filtros.form);

        // Restaurar propiedades
        this.tipoBusqueda = filtros.tipoBusqueda || "Propiedad";
        this.selectTipoBusquedaControl = filtros.selectTipoBusquedaControl || "3";

        // CORREGIDO: Restaurar estado del filtro avanzado ANTES de restaurar entidades
        this.checkedFiltroAvanzado = filtros.checkedFiltroAvanzado || false;

        // Restaurar entidades seleccionadas
        this.personaPropietarioDto = filtros.personaPropietarioDto;
        this.propiedadBaseDto = filtros.propiedadBaseDto;
        this.inquilinoDto = filtros.inquilinoDto;

        // Restaurar datos si existen
        if (filtros.contratoLista && filtros.data) {
          this.contratoLista = filtros.contratoLista;
          this.dataSource.data = this.contratoLista;
          this.data = filtros.data;
        }

        // AGREGADO: Actualizar el filtro según el tipo de búsqueda restaurado
        this.updateFilterByTipoBusqueda();
      }
    } catch (error) {
      console.error('Error restaurando filtros desde sesión:', error);
    }
  }

  clearFilter() {
    this.clearSelection()

    // Limpiar sessionStorage
    sessionStorage.removeItem(this.STORAGE_KEY);

    if (this.idInquilino > 0)
      this.getAllByIdInquilinoAndIdPropiedad(this.idInquilino, 0)
    if (this.idPropiedad > 0)
      this.getAllByIdInquilinoAndIdPropiedad(0, this.idPropiedad)
    if (!isFalsy(this.idPropietario))
      this.getAllByIdInquilinoAndIdPropiedad(0, this.idPropiedad)

    this.checkedFiltroAvanzado = false
    this.form.controls["Recindido"].setValue(false)
    this.form.controls["Finalizado"].setValue(false)
    this.form.controls["NumeroContrato"].setValue(null)
    this.form.controls["FechaDesde"].setValue(null)
    this.form.controls["FechaHasta"].setValue(null)
    this.form.controls["EstadosContrato"].setValue(null)
    this.form.controls["TiposContrato"].setValue(null)
    this.form.controls["TiposAjuste"].setValue(null)

    // Limpiar entidades seleccionadas
    this.personaPropietarioDto = undefined;
    this.propiedadBaseDto = undefined;
    this.inquilinoDto = undefined;

    this.dataSource.data = []
    this.data = false
  }

  filterContratos() {
    this.clearSelection()
    let idsEstadosContrato = isFalsy(this.form.controls["EstadosContrato"].value) ? null : this.form.controls["EstadosContrato"].value
    let idsTipoContrato = isFalsy(this.form.controls["TiposContrato"].value) ? null : this.form.controls["TiposContrato"].value
    let idsTipoAjusteContrato = isFalsy(this.form.controls["TiposAjuste"].value) ? null : this.form.controls["TiposAjuste"].value
    let idsTipoLiquidacion = isFalsy(this.form.controls["TiposLiquidacion"].value) ? null : this.form.controls["TiposLiquidacion"].value
    let nroContrato = isFalsy(this.form.controls["NumeroContrato"].value) ? null : this.form.controls["NumeroContrato"].value

    let fechaEmisionDesde = isFalsy(this.form.controls["FechaDesde"].value) ? null : this.datepipe.transform(this.form.controls["FechaDesde"].value, 'yyyy-MM-dd') as string;
    let fechaEmisionHasta = isFalsy(this.form.controls["FechaHasta"].value) ? null : this.datepipe.transform(this.form.controls["FechaHasta"].value, 'yyyy-MM-dd') as string;

    let idContrato = null
    let idInquilino = this.idInquilino && !isFalsy(this.idInquilino)
      ? this.idInquilino
      : (isFalsy(this.inquilinoDto) ? null : this.inquilinoDto.id)

    let idPropiedad = this.idPropiedad && !isFalsy(this.idPropiedad)
      ? this.idPropiedad
      : (isFalsy(this.propiedadBaseDto) ? null : this.propiedadBaseDto.id)

    let idPropietario = this.idPropietario && !isFalsy(this.idPropietario)
      ? this.idPropietario
      : (isFalsy(this.personaPropietarioDto) ? null : this.personaPropietarioDto.id_Propietario)


    let contratoFilter = new ContratoFilter
    contratoFilter.idContrato = idContrato
    contratoFilter.idInquilino = idInquilino
    contratoFilter.idPropiedad = idPropiedad
    contratoFilter.idPropietario = idPropietario
    contratoFilter.fechaComienzoDesde = fechaEmisionDesde
    contratoFilter.fechaComienzoHasta = fechaEmisionHasta
    contratoFilter.idsEstadoContrato = idsEstadosContrato
    contratoFilter.idsTipoContrato = idsTipoContrato
    contratoFilter.idsTipoLiquidacion = idsTipoLiquidacion
    contratoFilter.numeroContrato = nroContrato
    contratoFilter.idsTipoAjusteContrato = idsTipoAjusteContrato
    contratoFilter.idsFormaPagoPropietario = null

    this.getAllByFilter(contratoFilter)
    setTimeout(() => this.saveFiltersToSession(), 100);

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  /** Columnas por las que se puede buscar. Sólo una está activa a la vez. */
  private readonly columnasDeBusqueda: string[] = ['numeroContrato', 'inquilinoNombre', 'propietarioNombre', 'propiedadNombre'];

  /**
   * Cambiar el "Buscar por" tiene que soltar lo buscado antes.
   *
   * El término viejo quedaba vivo en filterValues: se elegía Propietario, se
   * escribía un nombre, y seguían apareciendo contratos que coincidían con la
   * búsqueda anterior por propiedad.
   */
  private limpiarTerminoDeBusqueda(): void {
    this.columnasDeBusqueda.forEach(col => delete this.filterValues[col]);

    this.formControlBuscar.setValue("", { emitEvent: false });
    this.dataSource.filter = JSON.stringify(this.filterValues);

    if (this.dataSource.paginator)
      this.dataSource.paginator.firstPage();
  }

  selectTipoBusqueda(event: any) {
    this.limpiarTerminoDeBusqueda();

    switch (event) {
      case "0":
        this.filter = { name: "numeroContrato", columnProp: "numeroContrato", options: [] }
        this.tipoBusqueda = "Nro. Contrato"
        break;
      case "1":
        this.filter = { name: "inquilinoNombre", columnProp: "inquilinoNombre", options: [] }
        this.tipoBusqueda = "Inquilino"
        break;
      case "2":
        this.filter = { name: "propietarioNombre", columnProp: "propietarioNombre", options: [] }
        this.tipoBusqueda = "Propietario"
        break;
      case "3":
        this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] }
        this.tipoBusqueda = "Propiedad"
        break;
      default:
        this.filter = { name: "numeroContrato", columnProp: "numeroContrato", options: [] }
        this.tipoBusqueda = "Nro. Contrato"
        break;
    }
  }

  onSelectionChangeEstadosContrato(event: any) {
    const selectedValue = event.value;
    const control = this.form.get('EstadosContrato');
    this.form.controls["EstadosContrato"].setValue(selectedValue)
  }

  onSelectionChangeTiposContrato(event: any) {
    const selectedValue = event.value;
    const control = this.form.get('EstadosContrato');
    this.form.controls["TiposContrato"].setValue(selectedValue)
  }

  onSelectionChangeTiposAjuste(event: any) {
    const selectedValue = event.value;
    const control = this.form.get('EstadosContrato');
    this.form.controls["TiposAjuste"].setValue(selectedValue)
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
      const filterValue = (event.target as HTMLInputElement).value;

      // Sólo puede haber un término de búsqueda: el de la columna elegida.
      this.columnasDeBusqueda.filter(col => col !== this.filter.columnProp)
                             .forEach(col => delete this.filterValues[col]);

      this.filterValues[this.filter.columnProp] = filterValue.toString().trim().toLowerCase().replace(/\s+/g, '')
      this.dataSource.filter = JSON.stringify(this.filterValues)

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  filterChangeEstados(filter: any, event: any) {
    this.filterValues[filter.columnProp] = event.value.trim().toLowerCase().replace(/\s+/g, '')
    this.dataSource.filter = JSON.stringify(this.filterValues)
  }

  getFilterObject(fullObj: any, key: any) {
    const uniqChk: any = [];
    fullObj.filter((obj: any) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

  /**
   * Filtro de la tabla.
   *
   * Los términos activos se combinan con Y, no con O. Antes alcanzaba con que
   * UNO coincidiera: buscando un propietario aparecían contratos de otro porque
   * seguía activo el término de una búsqueda anterior por propiedad.
   *
   * Un campo vacío o nulo nunca coincide, en vez de romper el filtro entero.
   */
  /**
   * Propietario que se muestra en la columna.
   *
   * Se prefiere el titular. Si ninguno está marcado como tal se usa el primero:
   * dejar la celda vacía escondía el dato y además rompía la búsqueda por
   * propietario, que compara contra ese mismo campo.
   */
  private asignarPropietarioTitular(contrato: ContratoLista, propietarios: any[]): void {
    if (isFalsy(propietarios) || propietarios.length === 0)
      return;

    const propietario = propietarios.find(p => p.titular == true) ?? propietarios[0];

    contrato.propietarioId = propietario.id
    contrato.propietarioNombre = isFalsy(propietario.persona) ? "" : propietario.persona.descripcion
  }

  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      const searchTerms = JSON.parse(filter);

      const terminosActivos = Object.keys(searchTerms)
        .filter(col => (searchTerms[col] ?? '').toString().replace(/\s+/g, '') !== '');

      if (terminosActivos.length === 0)
        return true;

      return terminosActivos.every(col => {
        const buscado = searchTerms[col].toString().trim().toLowerCase().replace(/\s+/g, '');
        const valor = (data[col] ?? '').toString().toLowerCase().replace(/\s+/g, '');

        return valor.indexOf(buscado) !== -1;
      });
    }
    return filterFunction
  }


  getAllByFilter(contratoFilter: ContratoFilter) {
    this.spinner.show()
    this.contratosService.getAllByFilter(contratoFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide()
          this.contratoLista = []

          data.forEach(element => {
            this.contratoLista.push(this.armarFilaContrato(element))
          });
          this.dataSource.data = this.contratoLista
          this.data = this.dataSource.data.length >= 1 ? true : false

          this.filterSelectObjEstados.filter((o) => {
            o.options = this.getFilterObject(this.contratoLista, o.columnProp);
          });

          // Guardar en sesión después de cargar datos
          this.saveFiltersToSession();
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getAllByIdInquilinoAndIdPropiedad(idInquilino: number, idPropiedad: number) {
    this.spinner.show()
    this.contratosService.getAllByIdInquilinoAndIdPropiedad(idInquilino, idPropiedad)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          this.spinner.hide()

          // Faltaba vaciar la lista, como sí hace getAllByFilter: si esta carga
          // se dispara dos veces, los contratos aparecían repetidos.
          this.contratoLista = []

          data.forEach(element => {
            this.contratoLista.push(this.armarFilaContrato(element))
          });
          this.dataSource.data = this.contratoLista
          this.data = this.dataSource.data.length >= 1 ? true : false

          this.filterSelectObjEstados.filter((o) => {
            o.options = this.getFilterObject(this.contratoLista, o.columnProp);
          });

        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  /**
   * Arma una fila de la grilla a partir del contrato que devuelve la API.
   *
   * Estaba duplicado en getAllByFilter y en getAllByIdInquilinoAndIdPropiedad, y
   * las dos copias ya se habían separado: la segunda nunca seteaba tipoAjuste,
   * así que al entrar desde una propiedad o un inquilino la columna Tipo Ajuste
   * salía vacía. Con un solo lugar, lo que se agregue vale para las dos vistas.
   */
  private armarFilaContrato(element: ContratoDetailDto): ContratoLista {
    let contrato = new ContratoLista

    contrato.id = element.id
    contrato.fechaFin = element.fechaVencimiento
    contrato.fechaInicio = element.fechaComienzo
    contrato.numeroContrato = element.numeroContrato
    contrato.legajo = "Tomo: " + element.tomo + "\nFolio: " + element.folio + "\nNúmero. " + element.numero

    contrato.inquilinoId = element.inquilino.persona.id
    contrato.inquilinoNombre = element.inquilino.persona.descripcion

    this.asignarPropietarioTitular(contrato, element.propietarios)

    contrato.propiedadId = element.propiedad.id
    contrato.propiedadNombre = (isFalsy(element.propiedad.ubicacion) ? '' : element.propiedad.ubicacion) +
      (isFalsy(element.propiedad.piso) ? '' : ' ' + element.propiedad.piso) +
      (isFalsy(element.propiedad.departamento) ? '' : ' ' + element.propiedad.departamento)
    contrato.propiedadLocalidad = isFalsy(element.propiedad.localidad) ? '' : element.propiedad.localidad

    contrato.porcentajeDiasCompletados = this.calcularPorcentajeDiasCompletados(element.fechaComienzo, element.fechaVencimiento)
    contrato.tipoContrato = element.tipoContrato.descripcion
    contrato.estadoNombre = element.estadoContrato.descripcion
    contrato.estadoId = element.estadoContrato.id

    // Puede venir sin tipo de ajuste (contratos viejos): no se asume que exista
    contrato.tipoAjuste = isFalsy(element.tipoAjusteContrato) ? '' : element.tipoAjusteContrato.acronimo

    contrato.contratoDto = element

    return contrato
  }

  calcularPorcentajeDiasCompletados(fechaComienzo: string, fechaVencimiento: string): number {
    const fechaComienzo1 = moment(new Date(fechaComienzo))
    const fechaVencimiento1 = moment(new Date(fechaVencimiento))
    const fechaHoy = moment(new Date())

    const x = fechaVencimiento1.diff(fechaComienzo1, 'days')
    const y = fechaVencimiento1.diff(fechaHoy, 'days')
    const dif = Math.round((y * 100) / x)

    return 100 - dif
  }

  progressInLoading() {
  }

  getById(id: number) {
    this.spinner.show()
    this.contratosService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide()
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }


  openDialogGenerarResumen(id: number) {
    this.spinner.show()
    this.contratosService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide()
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = "400px"
          dialogConfig.autoFocus = false
          dialogConfig.disableClose = true

          dialogConfig.data = { event: AccionesDialog.Agregar, contrato: data }
          const dialogRef = this.dialog.open(DialogGenerarResumenComponent,
            dialogConfig);

          dialogRef.afterClosed().subscribe(result => {
          });
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

// En tu componente
openDialogFechaLiquidacion(id: number): void {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '400px';
  dialogConfig.data = {
    mensaje: 'Seleccione la fecha de cierre para generar la liquidación del propietario'
  };

  const dialogRef = this.dialog.open(DialogFechaLiquidacionComponent, dialogConfig);

  dialogRef.afterClosed().subscribe((result: DialogFechaLiquidacionResult) => {
    if (result) {
      // Enviar al backend
      this.openDialogNuevaLiquidacion(id, result.fechaCierre);
    }
  });
}

  openDialogNuevaLiquidacion(id: number, fechaCierre:string) {
    this.spinner.show()
    this.contratosService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide()
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = "1080px"
          dialogConfig.data = {data:data,fechaCierre:fechaCierre}
          dialogConfig.autoFocus = false
          dialogConfig.disableClose = true

          const dialogRef = this.dialog.open(DialogNuevaLiquidacionComponent,
            dialogConfig);
          dialogRef.afterClosed().subscribe(result => {

          });
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  openDialogRescisionContrato(id: number) {
    this.spinner.show()
    this.contratosService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide()
          const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = false
          dialogConfig.disableClose = false
          dialogConfig.data = data

          const dialogRef = this.dialog.open(DialogRescisionContratoComponent,
            dialogConfig);

          dialogRef.afterClosed().subscribe(result => {
            if (result && result.event == AccionesDialog.Aceptar) {
              this.clearFilter()
            }
          });
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

  openDialogImputacionPropietario(contratoDetailDto: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = false
    dialogConfig.width = "70%"
    dialogConfig.data = contratoDetailDto

    const dialogRef = this.dialog.open(DialogImputacionPropietarioComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {

    });
  }


  rescisionContrato(resindirContratoRequest: ResindirContratoRequest) {
    this.spinner.show()
    this.contratosService.rescisionContrato(resindirContratoRequest)
      .subscribe(
        data => {
          this.spinner.hide()
          this.snackBar.showSuccess("Contrato resindido de manera correcta.", "Exito");
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }


  openDialogNuevoRecibo(id: number) {
    this.spinner.show()
    this.contratosService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide()
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = "100%"
          dialogConfig.data = { event: AccionesDialog.Agregar, contrato: data }
          dialogConfig.autoFocus = false
          dialogConfig.disableClose = true

          const dialogRef = this.dialog.open(DialogNuevoReciboComponent,
            dialogConfig);

          dialogRef.afterClosed().subscribe(result => {
          });
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }


  getAllEstadosContrato() {
    this.spinner.show("spBusquedaEstadosContrato")
    this.estadosContratoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaEstadosContrato")
          this.lstEstadosContrato = data
        },
        error => {
          this.spinner.hide("spBusquedaEstadosContrato")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getAllTiposContrato() {
    this.spinner.show("spBusquedaTiposContrato")
    this.tiposContratoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaTiposContrato")
          this.lstTiposContrato = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
        },
        error => {
          this.spinner.hide("spBusquedaTiposContrato")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  getAllTiposAjuste() {
    this.spinner.show("spBusquedaTiposAjuste")
    this.tipoAjusteContratoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaTiposAjuste")
          this.lstTiposAjuste = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
        },
        error => {
          this.spinner.hide("spBusquedaTiposAjuste")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }


  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false

    this.saveFiltersToSession();
  }

  selectPropietario(personaPropietarioDto: PersonaPropietarioDto) {
    this.personaPropietarioDto = personaPropietarioDto;
    this.saveFiltersToSession();
  }

  selectPropiedad(propiedadBaseDto: BaseDto) {
    this.propiedadBaseDto = propiedadBaseDto
    this.saveFiltersToSession();
  }

  selectInquilino(inquilinoDto: InquilinoDto) {
    this.inquilinoDto = inquilinoDto
    this.saveFiltersToSession();
  }

  selectRangoFecha(event: any) {
    this.rangoFecha = event.value
    if (this.rangoFecha == RangoFechasValores.Todos) {
      this.form.controls["FechaDesde"].setValue(new Date((new Date().getTime() - this.rangoFecha)))
      this.form.controls["FechaHasta"].setValue(new Date((new Date().getTime() + this.rangoFecha)))
    }
    else
      this.form.controls["FechaDesde"].setValue(new Date((new Date().getTime() - this.rangoFecha)))
  }


  trackByItems(index: number, item: any): any { return item; }

  // Alternar la selección de un contrato
  toggleSelection(contrato: ContratoLista) {
    this.selection.toggle(contrato);
  }

  // Puedes realizar alguna acción con los contratos seleccionados, por ejemplo:
  realizarAccionConSeleccionados() {
    const contratosSeleccionados = this.selection.selected;
    const idsSeleccionados = contratosSeleccionados.map(contrato => contrato.id); // Reemplaza 'id' con el nombre correcto de la propiedad ID en tu objeto

    // Aquí puedes agregar lógica para realizar acciones con los contratos seleccionados
  }



  // Limpia la selección de todos los checkboxes
  clearSelection(): void {
    this.selection.clear();
  }

  // Determina si todos los contratos VISIBLES están seleccionados
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length; // Cambio aquí
    return numSelected === numRows && numRows > 0;
  }

  // Seleccionar/deseleccionar todos los contratos VISIBLES
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.filteredData.forEach(row => this.selection.select(row)); // Cambio aquí
  }

  // Verifica si la selección es indeterminada (solo con datos visibles)
  isIndeterminate(): boolean {
    const numSelected = this.selection.selected.length;
    const numVisible = this.dataSource.filteredData.length; // Cambio aquí
    return numSelected > 0 && numSelected < numVisible;
  }

  // Método adicional para obtener solo contratos seleccionados que están visibles
  getSelectedVisibleContracts(): ContratoLista[] {
    return this.selection.selected.filter(contrato =>
      this.dataSource.filteredData.includes(contrato)
    );
  }

  // Actualizar el método de acción masiva para usar solo los visibles
  openDialogGenerarResumenMasivo() {
    // Obtener solo los contratos seleccionados que están visibles
    const contratosSeleccionadosVisibles = this.getSelectedVisibleContracts();
    const idsSeleccionados = contratosSeleccionadosVisibles.map(contrato => contrato.id);

    if (idsSeleccionados.length >= 1) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.width = "90%"
      dialogConfig.data = { event: AccionesDialog.Agregar, idContratos: idsSeleccionados }
      dialogConfig.disableClose = true

      const dialogRef = this.dialog.open(DialogGenerarResumenMensualComponent,
        dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.event == AccionesDialog.Aceptar) {
          this.snackBar.showSuccess("Proceso realizado correctamente.", "Exito");
          this.resultadoResumenInquilinoEnvioCorreoService.setResultadoProcesoResumenMasivoInquilinosDto(result.data);
          this.router.navigate(["/generacionresumenmensual"])
          this.selection.clear()
        }

        if (result && result.event == AccionesDialog.Cancelar)
          this.snackBar.showInfo("Proceso cancelado.", "Info");
      });
    }
    else
      this.snackBar.showInfo("Previamente debe seleccionar algun contrato.", "Info");
  }

  // Método opcional para mostrar información de selección
  getSelectionInfo(): string {
    const totalVisible = this.dataSource.filteredData.length;
    const selectedVisible = this.getSelectedVisibleContracts().length;
    return `${selectedVisible} de ${totalVisible} contratos seleccionados`;
  }


  openDialogEliminarContrato(contratoId: number): void {
    const contrato = this.contratoLista.find(c => c.id === contratoId);

    const dialogRef = this.dialog.open(DeleteConfirmationModalComponent, {
      width: '650px',
      disableClose: true,
      data: {
        title: 'Eliminar Contrato',
        entityName: 'Contrato',
        entityDetails: {
          'Número': contrato?.numeroContrato?.toString() || 'N/A',
          'Inquilino': contrato?.inquilinoNombre || 'N/A',
          'Propiedad': contrato?.propiedadNombre || 'N/A',
          'Estado': contrato?.estadoNombre || 'N/A'
        },
        warningMessage: 'La eliminación del contrato eliminará permanentemente toda la información relacionada y no se podrá recuperar.',
        relatedItems: [
          'Todos los movimientos financieros',
          'Comprobantes y detalles asociados',
          'Pagos registrados',
          'Períodos del contrato',
          'Archivos temporales',
          'Relaciones con propietarios y garantías'
        ],
        confirmationText: 'ELIMINAR',
        isDestructive: true
      }
    });

    dialogRef.afterClosed().subscribe((result: DeleteConfirmationModalResult) => {
      if (result?.confirmed) {
        this.eliminarContrato(contratoId, result.reason);
      }
    });
  }

  // AGREGADO: Método para actualizar el filtro según el tipo de búsqueda
  private updateFilterByTipoBusqueda(): void {
    switch (this.selectTipoBusquedaControl) {
      case "0":
        this.filter = { name: "numeroContrato", columnProp: "numeroContrato", options: [] };
        this.tipoBusqueda = "Nro. Contrato";
        break;
      case "1":
        this.filter = { name: "inquilinoNombre", columnProp: "inquilinoNombre", options: [] };
        this.tipoBusqueda = "Inquilino";
        break;
      case "2":
        this.filter = { name: "propietarioNombre", columnProp: "propietarioNombre", options: [] };
        this.tipoBusqueda = "Propietario";
        break;
      case "3":
        this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] };
        this.tipoBusqueda = "Propiedad";
        break;
      default:
        this.filter = { name: "propiedadNombre", columnProp: "propiedadNombre", options: [] };
        this.tipoBusqueda = "Propiedad";
        break;
    }
  }

  private eliminarContrato(contratoId: number, reason?: string): void {
    this.spinner.show();

    this.contratosService.eliminarContratoCompleto(contratoId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.snackBar.showSuccess('Contrato eliminado exitosamente', 'Éxito');

          // Quitar el contrato de la lista local sin recargar
          this.contratoLista = this.contratoLista.filter(c => c.id !== contratoId);
          this.dataSource.data = this.contratoLista;
          this.data = this.dataSource.data.length >= 1;

          // Quitar de la selección si estaba seleccionado
          const contratoSeleccionado = this.selection.selected.find(c => c.id === contratoId);
          if (contratoSeleccionado) {
            this.selection.deselect(contratoSeleccionado);
          }

          // Guardar estado actualizado en sesión
          this.saveFiltersToSession();
        },
        error: (error) => {
          this.spinner.hide();
          this.snackBar.showError('Error al eliminar el contrato', 'Error');
          console.error('Error eliminando contrato:', error);
        }
      });
  }
}
